import { ContentPoster } from '../../content-poster.model';
import { Metadata } from '../../metadata.model';
import { PlanProfile } from "../../plan-profile/plan-profile.model";
import { VODStream } from '../../vod-stream.model';
import { CensorshipPreview } from '../../censorship-preview.model';
import { LanguageOption } from '../../language-option.model';

export class Catchup {
  constructor(
    public actualBegin?: number,
    public actualEnd?: number,
    public cdrId?: string,
    public channelId?: number,
    public channelName?: string,
    public endTime?: number,
    public guid?: string,
    public id?: number,
    public isValidMetadata?: boolean,
    public isValidPoster?: boolean,
    public metadata?: Metadata,
    public mwChannelId?: string,
    public name?: string,
    public parentGuid?: string,
    public parentId?: number,
    public parentSeriesId?: number,
    public planned?: boolean,
    public migrated?: boolean,
    public playUrl?: string,
    public trimmedPlayUrl?: string,
    public rawDefaultArchiveUrl?: string,
    public rawHlsArchiveUrl?: string,
    public rawDashArchiveUrl?: string,
    public flussonicEpisodeId?: number,
    public flussonicStreamName?: string,
    public flussonicStreamServerUrl?: string,
    public flussonicRegistrationStatus?: string,
    public flussonicLastSyncTime?: number,
    public flussonicLastError?: string,
    public posters?: ContentPoster[],
    public releaseDate?: string,
    public seriesId?: string,
    public startTime?: number,
    public status?: string,
    public type?: string,
    public trimmed?: string,
    public programGeneratedSeriesId?: string,
    public startFrameSecond?: number,
    public advertorialRights?: string,
    public mwInternalCode?: string,
    public planMinStartTime?: number,
    public planMaxEndTime?: number,
    public catchupSectionInfo?: string,
    public publishTime?: number,
    public planProfiles?: PlanProfile[],
    public bufferTime?: number,
    public mediaFileStatus?: string,
    public keywords?: string,
    public isAdult?: boolean,
    public streams?: VODStream[],
    public comingSoon?: boolean,
    public censorshipPreview?: CensorshipPreview,
    public censorshipStatus?: string,
    public seriesName?: string,
    public hidden?: boolean,
    public preserveOnExpiry?: boolean,
    public languageOptions?: LanguageOption[]
  ) { }
}
